import React from 'react'

// components
import Hero from '../../components/Hero/Hero.jsx'
import BuyShangu from '../../components/BuyShangu/BuyShangu.jsx'
import Artwork from '../../components/Artwork/Artwork.jsx'
import Roadmap from '../../components/Roadmap/Roadmap.jsx'
import OurTeam from '../../components/Our Team/OurTeam.jsx'
import Faq from '../../components/FAQ/Faq.jsx'
import Footer from '../../components/Footer/Footer.jsx'
import CarouselSlider from '../../components/Carousel Slider/CarouselSlider.jsx'
import Giveaway from '../../components/Giveaway/Giveaway.jsx'
import Discord from '../../components/Discord/Discord'
import Charity from '../../components/Charity/Charity'
import P2Game from '../../components/P2Game/P2Game'

import RoadMapNew from '../../components/RoadMapNew/RoadMapNew'
import TheArtist from '../../components/TheArtist/TheArtist'
import Joinclub from '../../components/JoinClub/Joinclub.jsx'

const Homepage = (props) => {
    console.log("Mainnet 2pm-3feb");
    return (
        <div>
            <Hero />

            <BuyShangu metaAddress={props.metamaskAddress} connectWallet={props.connectWallet}/>
            <TheArtist />
            <Artwork />

            <CarouselSlider />

            {/* <Roadmap /> */}
            {/* <TheArtist /> */}
            <Joinclub />
            <RoadMapNew />

            <Giveaway />

            <P2Game />

            <OurTeam />

            <Charity />
            <Discord />
            <Faq />

            <Footer />
        </div>
    )
}

export default Homepage
